import { render, staticRenderFns } from "./ModalSkills.vue?vue&type=template&id=6a214a12&scoped=true&"
import script from "./ModalSkills.vue?vue&type=script&lang=js&"
export * from "./ModalSkills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a214a12",
  null
  
)

export default component.exports